const SANTA_HATS = [
  {
    slug: "santa-red-0",
    name: "Santa",
    description: "I know him!",
    rarity: "legendary",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 50
      },
      {
        stat: "redRes",
        value: 25
      },
      {
        stat: "blackColor",
        value: 15
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 0
    },
    tags: ["december", "daily-rotation"],
    shopCategory: "hat"
  },
  {
    slug: "santablack-black-0",
    name: "Santablack",
    description: "Halloween isn't over yet",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 35
      },
      {
        stat: "blackRes",
        value: 15
      },
      {
        stat: "redColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 0
    },
    tags: ["november", "daily-rotation"],
    shopCategory: "hat"
  }
];
export {
  SANTA_HATS
};
//# sourceMappingURL=data:application/json;base64,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
